import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { CallAPIService } from 'src/app/services/call-api.service';
import { regex } from 'src/app/constants/regex';
import { MatDialog } from '@angular/material/dialog';
import { OpenExternalUrlDialogComponent } from '../../utility/open-external-url-dialog/open-external-url-dialog.component';
import { AngularFireAnalytics } from '@angular/fire/compat/analytics';
import { CachingService } from 'src/app/services/caching.service';
import { cacheKeys } from 'src/app/constants/cache-keys';
import { StoreService } from 'src/app/services/store.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit, OnDestroy {
  emailSubsForm!: FormGroup;
  newsletterSubs!: Subscription;
  isLoading!: boolean;
  emailSubsResp = '';
  pakageJSON = require('../../../../../package.json');

  @ViewChild('emailInput') emailInputRef!: ElementRef;
  usefulLinks = [
    {
      url: 'https://negd.gov.in/',
      img: 'https://media.umangapp.in/cdn/landing/theme/icons/negd.svg',
      title: 'NeGD',
      alt: 'NeGD',
      isVisible: true,
    },
    {
      url: 'https://www.digitalindia.gov.in/',
      img: 'https://media.umangapp.in/cdn/landing/theme/icons/digital-logo.svg',
      title: 'Digital India',
      alt: 'Digital India',
      isVisible: true,
    },
    {
      url: 'https://www.digilocker.gov.in/',
      img: 'https://media.umangapp.in/cdn/landing/theme/icons/digilocker.svg',
      title: 'Digilocker',
      alt: 'Digilocker',
      isVisible: false,
    },
    {
      url: 'https://www.mygov.in/',
      img: 'https://media.umangapp.in/cdn/landing/theme/icons/mygov.svg',
      title: 'myGov',
      alt: 'myGov',
      isVisible: true,
    },
    {
      url: 'https://www.india.gov.in/',
      img: 'https://media.umangapp.in/cdn/landing/theme/icons/Indiagovin.svg',
      title: 'India Gov',
      alt: 'India Gov',
      isVisible: true,
    },
    {
      url: 'https://data.gov.in/',
      img: 'https://media.umangapp.in/cdn/landing/theme/icons/datagov.svg',
      title: 'Data Gov',
      alt: 'Data Gov',
      isVisible: false,
    },
  ];
  totalVisitCount: any;
  constructor(
    private translateService: TranslateService,
    private callApiService: CallAPIService,
    private dialog: MatDialog,
    private analytics: AngularFireAnalytics,
    private cachingService: CachingService,
    private storeService: StoreService
  ) {}

  ngOnInit() {
    this.storeService.updateVisitCount.subscribe((res) => {
      const count: any = this.cachingService.fetchCachedData(
        cacheKeys.userCounts
      );
      console.warn('Count', count);
      this.totalVisitCount = count?.['data']['web'];
    });
    this.initEmailSubsForm();
  }

  private initEmailSubsForm() {
    this.emailSubsForm = new FormGroup({
      email: new FormControl('', [
        Validators.required,
        Validators.pattern(regex.email),
      ]),
    });
  }

  get emailControl() {
    return this.emailSubsForm.get('email')!;
  }

  get isEmailSubsSuccess() {
    return this.emailSubsResp.includes('success');
  }

  onSubscribe() {
    // If "email" control has erros then mark it as touched, so that errors could be shown in UI
    if (this.emailControl.errors) {
      this.emailControl.markAsTouched();
      return;
    }

    this.isLoading = true;
    this.emailSubsResp = '';
    this.emailControl.disable();
    (<HTMLInputElement>this.emailInputRef.nativeElement).blur();

    const newsletterEssentials = (respMesg = 'error.oops') => {
      this.isLoading = false;
      this.emailSubsResp = respMesg;

      // Append "*" at first place if the string is not a sucess response
      this.emailSubsResp = `${
        this.isEmailSubsSuccess ? '' : '*'
      }${this.translateService.instant(respMesg)}`;

      // Clear the subscription API response from UI
      const timeoutRef = setTimeout(() => {
        this.emailSubsResp = '';
        clearTimeout(timeoutRef);
      }, 3000);

      this.emailControl.enable();
      this.emailSubsForm.reset();
    };

    this.newsletterSubs = this.callApiService
      .subscribeToNewsletter(this.emailControl.value)
      .subscribe({
        next: ({ rd }) => {
          newsletterEssentials(rd);
        },
        error: (error) => {
          newsletterEssentials();
        },
      });
  }

  openLink(item: any) {
    this.dialog.open(OpenExternalUrlDialogComponent, { data: item });
  }

  logISLEvent() {
    this.analytics.logEvent('isl_event', {
      category: 'ISL Page Click',
      action: 'clicked',
      label: 'isl_page_click',
    });
  }

  ngOnDestroy() {
    this.newsletterSubs?.unsubscribe();
  }
}
